import { cn } from '../../lib/utils';

interface HtmlRendererProps {
  html: string;
  className?: string;
}

export function HtmlRenderer({ html, className }: HtmlRendererProps) {
  if (!html || html === '<p></p>') {
    return (
      <p className={cn('text-text-muted italic', className)}>
        No description provided
      </p>
    );
  }

  return (
    <div
      className={cn(
        'prose prose-invert max-w-none',
        // Headings
        'prose-h1:text-2xl prose-h1:font-bold prose-h1:text-text prose-h1:mt-6 prose-h1:mb-4',
        'prose-h2:text-xl prose-h2:font-semibold prose-h2:text-text prose-h2:mt-5 prose-h2:mb-3',
        'prose-h3:text-lg prose-h3:font-medium prose-h3:text-text prose-h3:mt-4 prose-h3:mb-2',
        // Paragraphs
        'prose-p:text-text-secondary prose-p:leading-relaxed prose-p:my-3',
        // Lists
        'prose-ul:my-3 prose-ul:pl-6 prose-ul:list-disc',
        'prose-ol:my-3 prose-ol:pl-6 prose-ol:list-decimal',
        'prose-li:text-text-secondary prose-li:my-1',
        // Links
        'prose-a:text-accent prose-a:underline hover:prose-a:text-accent-light',
        // Code
        'prose-code:bg-bg-tertiary prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-sm prose-code:text-accent',
        'prose-pre:bg-bg-tertiary prose-pre:rounded-lg prose-pre:p-4 prose-pre:overflow-x-auto',
        // Blockquotes
        'prose-blockquote:border-l-4 prose-blockquote:border-accent/50 prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-text-muted',
        // Images
        'prose-img:rounded-lg prose-img:max-w-full prose-img:my-4',
        // Strong/emphasis
        'prose-strong:text-text prose-strong:font-semibold',
        'prose-em:italic',
        // Mentions
        '[&_.mention]:bg-accent/20 [&_.mention]:text-accent [&_.mention]:px-1.5 [&_.mention]:py-0.5 [&_.mention]:rounded [&_.mention]:font-medium',
        '[&_[data-type="mention"]]:bg-accent/20 [&_[data-type="mention"]]:text-accent [&_[data-type="mention"]]:px-1.5 [&_[data-type="mention"]]:py-0.5 [&_[data-type="mention"]]:rounded [&_[data-type="mention"]]:font-medium',
        className
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
